// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import ActivityLog from "../../components/dashboard/ActivityLog";

export default function ActivityLogPage() {
  return (
    <DashboardLayout>
      <ActivityLog />
    </DashboardLayout>
  );
}
